import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GrievanceDashboardComponent } from './grievance-dashboard/grievance-dashboard.component';
import { User1Component } from './user1/user1.component';
import { GrievanceLinkComponent } from './grievance-link/grievance-link.component';
import { EmpGrievanceLinkComponent } from './emp-grievance-link/emp-grievance-link.component';
import { AdminComponent } from './admin/admin.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { SuperAdminComponent } from './super-admin/super-admin.component';
import { SuperAdminDashboardComponent } from './super-admin-dashboard/super-admin-dashboard.component';

const routes: Routes = [
  {
    path: 'employeeGrievance',
    component: EmpGrievanceLinkComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: GrievanceLinkComponent },
      { path: 'ticketDetails', component: User1Component },
      { path: 'admin', component: AdminDashboardComponent },
       { path: 'superAdmin', component: SuperAdminDashboardComponent },
    ],
  },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployeeGrevienceRoutingModule { }
